import { render, staticRenderFns } from "./RegisterPixKeyValidation.vue?vue&type=template&id=f0b7645a&"
import script from "./RegisterPixKeyValidation.vue?vue&type=script&lang=js&"
export * from "./RegisterPixKeyValidation.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPixKeyValidation.vue?vue&type=style&index=0&id=f0b7645a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports